module.exports = __webpack_public_path__ + "img/10.961bee45.jpg";